export default __webpack_public_path__ + "125e43a2cb1ca9a3b3a6b3fcb666a1a8.png";